import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Roadmap from './pages/Roadmap';
import { FinancialProvider } from './context/FinancialContext';
import './App.css';

function App() {
  return (
    <FinancialProvider>
      <Router>
        <div className="min-h-screen bg-slate-50 app-container">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/roadmap" element={<Roadmap />} />
          </Routes>
        </div>
      </Router>
    </FinancialProvider>
  );
}

export default App;